import { Form, Input, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { LoginOtpVeryficationApi, ResendOtpApi } from '../../api/request/auth';
import { setloggedIn, setUserDetails, setTimer } from "../../store/Slices/userSlice.js";
import LoadableButton from '../../components/button/LoadableButton';
import { useDispatch, useSelector } from 'react-redux';
import { removeCookies, setCookies } from '../../services/Cookies.jsx';

const Otp = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userDetails = useSelector((state) => state.user.userDetails);
    const [form] = Form.useForm();
    const email = localStorage.getItem('email');  
    const [initialValues] = useState({ otp: '' });
    const [isOtpLoading, setIsOtpLoading] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const timer = userDetails?.timer || 0;
    const [intervalId, setIntervalId] = useState(null);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    };

    const startTimer = (duration) => {
        if (intervalId) clearInterval(intervalId); // Clear existing timer

        let timeLeft = duration;
        dispatch(setTimer(timeLeft));

        const id = setInterval(() => {
            timeLeft -= 1;
            dispatch(setTimer(timeLeft));
            if (timeLeft <= 0) {
                clearInterval(id);
                setIntervalId(null);
            }
        }, 1000);

        setIntervalId(id);
    };

    const handleSubmit = async (values) => {
        try {
            setIsOtpLoading(true);
            const params = { ...values, email };
            const { data } = await LoginOtpVeryficationApi(params);
            if (data?.status) {
                setCookies('token', data?.token);
                dispatch(setloggedIn(true));
                dispatch(setUserDetails(data?.data));
                localStorage.removeItem('email');
                form.resetFields();
                toast.success(data?.message);
                navigate('/dashboard');
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setIsOtpLoading(false);
        }
    };

    const handleResend = async () => {
        try {
            setLoading(true);
            const { data } = await ResendOtpApi({ email });
            if (data?.status) {
                toast.success(data?.message);
                startTimer(59); // Restart the timer
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to resend OTP");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (timer > 0) {
            startTimer(timer);
        }
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [timer]);

    return (
        <div className='lg:w-3/5 md:w-[80%] w-full sm:p-0 p-4'>
        <Form autoComplete='off' onFinish={handleSubmit} form={form} initialValues={initialValues} className='space-y-8'>
            <div className='text-center'>
                <p className='font-bold sm:text-3xl text-2xl mb-3'>OTP Verification</p>
                <p className="text-sm text-Gray">
                    {`A security code has been sent to your-${email}.`} <br />
                    {` Please enter the code below to continue.`}
                </p>
            </div>
            <Form.Item name="otp" rules={[{ required: true }]}>
                <Input.OTP size='large' style={{ width: '100%' }} />
            </Form.Item>
            <div className='text-center'>
                {isLoading ? <Spin /> : (
                    !timer ? (
                        <p className='font-semibold text-sm flex justify-center w-full'>
                            Didn't receive it?
                            <span className='text-primary font-bold underline ml-1 cursor-pointer' onClick={handleResend}>
                                Resend
                            </span>
                        </p>
                    ) : (
                        <p className='font-semibold text-sm'>Didn't receive it? You can request a new code in {formatTime(timer)}.</p>
                    )
                )}
            </div>
            <LoadableButton
                isLoading={isOtpLoading}
                type='submit'
                lable='Verify'
                img='assets/icons/ArrowRight.svg'
                loadingLabel='Verifying otp...'
                className='bg-secondary text-white text-base w-full py-2 rounded-md mb-5 flex justify-center items-center'
            />
            <div className='text-primary flex items-center justify-center mb-5'>
                <img src="assets/icons/ArrowLeft.svg" alt="icon" className='me-3' />
                <Link to='/login'>Back to login</Link>
            </div>
        </Form>
    </div>
    );
};

export default Otp;
